import { Button, Checkbox, Input, message, Popconfirm, Select } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import API_HOST from "../config.js";
import { testProfile } from "./cancelFunction.js";

function AddNewVisaVerifyPersonal(props) {
  const [loading, setLoading] = useState(false);
  const [profileModel, setProfileModel] = useState(testProfile);
  const [messageApi, contextHolder] = message.useMessage();
  const [needDisable, setNeedDisable] = useState(false);
  const [needVerifyPayment, setNeedVerifyPayment] = useState(false);
  const [manual, setManual] = useState(true);

  const [quantity, setQuantity] = useState('5');

  const [sheetURL, setSheetURL] = useState('');
  const [sheetName, setSheetName] = useState('Trang Tính1');

  const addVisa = async (profile) => {
    if(!sheetURL) {
      alert("Link GG Sheet chưa nhập !!!")
      return;
    }
    messageApi.info(`Profile: ${profile.name} >>> Add visa + XM TKCN...`);
    let body = {
      profile: profile,
      needDisable,
      needVerifyPayment,
      manual,
      quantity,
      sheet: {
        sheetId: sheetURL.split('/d/')[1].split('/edit')[0], 
        sheetName: sheetName,
      }
    };
    axios
      .post(`${API_HOST}/api/add-visa-verify-personal`, body)
      .then((res) => messageApi.success("Đang chạy..."))
      .catch((e) => {
        console.log("🚀 ~ add-new-visa ~ e:", e);
        messageApi.error(e.response.data);
      });
  };
  useEffect(() => {
    let sheetName = localStorage.getItem('tkcn-sheetName')
    if(sheetName) {
      setSheetName(sheetName)
    }
    let sheetURL = localStorage.getItem('tkcn-sheetURL')
    if(sheetURL) {
      setSheetURL(sheetURL)
    }
  }, [])

  const onOpenChange = (open) => {
    if (open) {
      setLoading(true);
      axios
        .get(`${API_HOST}/api/profiles/${props.profile.id}`)
        .then((res) => {
          setLoading(false);
          if (res.data) {
            setProfileModel(res.data[0]);
          }
        })
        .catch((e) => {
          setLoading(false);
          messageApi.error("Không thể lấy thông tin Profile");
        });
    }
  };

  return (
    <>
      {contextHolder}
      <Popconfirm
        style={{ width: '500px' }}
        onOpenChange={onOpenChange}
        placement="left"
        okText="OK"
        cancelText="Hủy"
        title="Xác nhận: Add Visa + XM D.U.N.S TKCN"
        description={
          <div style={{ width: '500px' }}>
            {profileModel?.errorMsg?.length > 0 && (
              <label style={{ color: "red", border: "1px solid red" }}>
                <strong>{profileModel?.errorMsg}</strong>
              </label>
            )}
           
            <Checkbox checked={needDisable} onChange={e => setNeedDisable(e.target.checked)}>
              Hủy TK Sau Khi Add
            </Checkbox>
            <br />
            <Checkbox checked={needVerifyPayment} onChange={e => setNeedVerifyPayment(e.target.checked)}>
              Xác Minh Thẻ
            </Checkbox>
            <br />
            <label>Số Lượng TK: </label>
              <Input
                value={quantity}
                type="number"
                style={{ width: 60 }}
                placeholder="Số Lượng ..."
                onChange={(e) => setQuantity(e.target.value)}
              />
            <br />
            {needVerifyPayment && <>
              <Checkbox checked={manual} onChange={e => setManual(e.target.checked)}>
                Lấy CODE Thủ Công
              </Checkbox>
              <br />
            </>}
            <br />
            <b>Data GG sheet: </b>
            <br />
            <label>URL: </label>
            <Input
              value={sheetURL}
              style={{ width: 400 }}
              placeholder="https://docs.google.com/spreadsheets/d/15CVrJD5DBJ5k..."
              onChange={(e) => {
                setSheetURL(e.target.value);
                localStorage.setItem('tkcn-sheetURL', e.target.value);
              }}
            />
            <br />
            <label>Trang: </label>
            <Input
              value={sheetName}
              style={{ width: 200 }}
              placeholder="SheetName ..."
              onChange={(e) => {
                setSheetName(e.target.value);
                localStorage.setItem('tkcn-sheetName', e.target.value);
              }}
            />
          </div>
        }
        onConfirm={() => addVisa(props.profile)}
      >
        <Button style={{backgroundColor:'green', color:'white'} }loading={loading}>
          <b>Add Visa + XM TKCN</b>
        </Button>
      </Popconfirm>
    </>
  );
}
export default AddNewVisaVerifyPersonal;
